export const environment = {
  production: false,
  apiUrl: ' https://igaltex-test.zafirus.tech/api',
  crypto: 'TH123H21',
};
